import React, { Fragment, useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';

import {
    ButtonGroup, Button, CircularProgress, IconButton
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';


import { Avatar } from 'antd';
import Icon from '@mdi/react';
import {
    mdiDelete, mdiPin, mdiPinOff, mdiCloseOctagon, mdiEye,
    mdiFilePdfBox, mdiMicrosoftExcel, mdiEmailArrowRight
} from '@mdi/js';

import {
    downloadTrack,
    setTrackDetailView, setTimeLineView, setbottomView,
    trackDetailViewSelector, pinnedTracksSelector,
    addToPinnedTracks, removefromPinnedTracks,
} from '../../features/datacenter/historySlice';

import { deleteReport, getExcel, getPdf, } from '../../features/datacenter/datacenterApi';
import { assetNamesSelector } from '../../features/assets/assetsSlice';
import { setNeedBounding } from '../../features/map/mapSlice';
import GetPdfForm from '../common/GetPdfForm';



const TrackListItem = ({ reportID }) => {

    const dispatch = useDispatch();
    const trackData = useSelector(state => state.history.trackData[reportID]);
    const trackDetailView = useSelector(trackDetailViewSelector);
    const pinnedTracks = useSelector(pinnedTracksSelector);
    const trackIsPinned = pinnedTracks.indexOf(reportID) !== -1;
    const trackIsDetailView = reportID === trackDetailView;

    const assetNames = useSelector(assetNamesSelector);
    const icon = assetNames && trackData && assetNames[trackData.reqBody.imei] && assetNames[trackData.reqBody.imei].icon;


    const showTimeLine = (type) => {
        dispatch(setTimeLineView(reportID));
        dispatch(setbottomView(type));
    }

    const closeTimeLine = () => {
        dispatch(setTimeLineView(null));
        dispatch(setbottomView('trackList'));
    }

    const deleteTrackCallback = () => {
        dispatch(setTimeLineView(null));
        dispatch(setbottomView('trackList'));
        dispatch(deleteReport(reportID));
    }

    const addToPinnedTracksCallback = () => {
        dispatch(addToPinnedTracks(reportID));
        dispatch(setNeedBounding(true));
    };

    const removefromPinnedTracksCallback = () => {
        dispatch(removefromPinnedTracks(reportID));
    };

    const setTrackDetailviewCallback = () => {
        if (!trackData.dataTable) {
            dispatch(downloadTrack(reportID));
        }
        dispatch(setTrackDetailView(reportID));
        dispatch(setNeedBounding(true));
        showTimeLine("summary");
    };

    const removeTrackDetailViewCallback = () => {
        dispatch(setTrackDetailView(null));
        closeTimeLine();
    }

    const [getPdfFormOpen, setgetPdfFormOpen] = useState(false);
    const handleGetPdfFormClose = () => {
        setgetPdfFormOpen(false);
    }

    useEffect(() => {
        if (trackData) {
            console.log("Report Data", reportID, trackData.reportID, trackData);
        } else {
            console.log("Trackdata aint ready", reportID);
        }

    }, [trackData, reportID])

    if (trackData && trackData.reqBody) {
        return (
            <div>
                <Card
                    style={{
                        backgroundColor: trackIsDetailView ? 'WhiteSmoke' : 'White',
                        marginBottom: '2px'
                    }}
                >
                    <CardHeader
                        avatar={
                            <Avatar style={{ backgroundColor: 'white' }}>
                                <img alt="a" src={icon ? `/assets/markers/def30/${icon}` : `/assets/markers/def30/cargo_van_purple.png`} />
                            </Avatar>
                        }
                        title={<b>{trackData.assetName}</b>}
                        subheader={
                            <Fragment>
                                <Typography variant="subtitle2" color="textSecondary" component="span">
                                    <b>Start: </b> {`${moment(trackData.reqBody.timeFrom).format('Do MMM YY hh:mm A')}`}
                                </Typography>
                                <br />
                                <Typography variant="subtitle2" color="textSecondary" component="span">
                                    <b>End: </b> {`${moment(trackData.reqBody.timeTo).format('Do MMM YY hh:mm A')}`}
                                </Typography>

                            </Fragment>
                        }
                        action={
                            trackData.status === 'submitted' ?
                                <Button
                                    startIcon={
                                        <CircularProgress color="secondary" size={20} />
                                    }
                                    onClick={() => { }}
                                >
                                    <b><i><span style={{ color: 'red' }}>Building</span></i></b>
                                </Button>
                                :
                                trackData.status === 'nodata' ?
                                    <Button
                                        startIcon={
                                            <Icon
                                                path={mdiDelete}
                                                title="Delete Report"
                                                size={0.8}
                                                color="Red"
                                            />
                                        }
                                        onClick={deleteTrackCallback}
                                    >
                                        <b><i><span style={{ color: 'red' }}>No Data</span></i></b>
                                    </Button>
                                    :
                                    <ButtonGroup>
                                        {
                                            trackIsPinned ?
                                                <Tooltip title="Pin This Track">
                                                    <IconButton onClick={removefromPinnedTracksCallback} size="large">
                                                        <Icon
                                                            path={mdiPin}
                                                            title="Pin this Track"
                                                            size={0.8}
                                                            color={trackData.trackColor}
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                                :
                                                <Tooltip title="Unpin This Track">
                                                    <IconButton onClick={addToPinnedTracksCallback} size="large">
                                                        <Icon
                                                            path={mdiPinOff}
                                                            title="Unpin This Track"
                                                            size={0.8}
                                                            color="Gray"
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                        }
                                        {
                                            trackIsDetailView ?
                                                trackData.dataTable ?
                                                    <IconButton
                                                        onClick={removeTrackDetailViewCallback}
                                                        variant="text"
                                                        size="small"
                                                    >
                                                        <Icon
                                                            path={mdiCloseOctagon}
                                                            title="Hide Track Player"
                                                            size={0.8}
                                                            color="Crimson"
                                                        />
                                                    </IconButton>
                                                    :
                                                    <CircularProgress color="secondary" />
                                                :
                                                <IconButton
                                                    onClick={setTrackDetailviewCallback}
                                                    variant="text"
                                                    size="small"
                                                >
                                                    <Icon
                                                        path={mdiEye}
                                                        title="Show Track Player"
                                                        size={0.8}
                                                        color={trackData.trackColor}
                                                    />
                                                </IconButton>
                                        }
                                    </ButtonGroup>
                        }
                    />
                    {
                        trackData.status === 'ready' &&
                        <CardActions>
                            <ButtonGroup>
                                <Tooltip title="Download Excel">
                                    <IconButton onClick={() => dispatch(getExcel(reportID))} size="large">
                                        <Icon
                                            path={mdiMicrosoftExcel}
                                            title="Download Excel"
                                            size={0.8}
                                            color="Green"
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Download PDF">
                                    <IconButton onClick={() => dispatch(getPdf(reportID))} size="large">
                                        <Icon
                                                path={mdiFilePdfBox}
                                            title="Download PDF"
                                            size={0.8}
                                            color="Crimson"
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Email PDF">
                                    <IconButton onClick={() => setgetPdfFormOpen(true)} size="large">
                                        <Icon
                                                path={mdiEmailArrowRight}
                                            title="Email PDF"
                                            size={0.8}
                                            color="Teal"
                                        />
                                    </IconButton>
                                </Tooltip>
                                {/*<Tooltip title="Share Track">
                                    <IconButton
                                        disabled
                                        onClick={() => { }}
                                    >
                                        <Icon
                                            path={mdiShareVariant}
                                            title="Share Track"
                                            size={0.8}
                                            color="DodgerBlue"
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Save This Track">
                                    <IconButton
                                        disabled
                                        onClick={() => { }}
                                    >
                                        <Icon
                                            path={mdiContentSave}
                                            title="Save This Track"
                                            size={0.8}
                                            color="DarkMagenta"
                                        />
                                    </IconButton>
                    </Tooltip>*/}

                                <Tooltip title="Delete Track">
                                    <IconButton onClick={deleteTrackCallback} size="large">
                                        <Icon
                                            path={mdiDelete}
                                            title="Delete Track"
                                            size={0.8}
                                            color="Red"
                                        />
                                    </IconButton>
                                </Tooltip>

                            </ButtonGroup>
                        </CardActions>

                    }
                </Card>

                <GetPdfForm
                    getPdfFormOpen={getPdfFormOpen}
                    handleGetPdfFormClose={handleGetPdfFormClose}
                    reportIDs={[reportID]}
                />
            </div>
        );
    } else {
        return null;
    }
}

export default TrackListItem;

/*
 {
                        trackData.dataTable &&
                        <CardActions disableSpacing>
                            <Tooltip title="Show Timeline">
                                <IconButton onClick={() => showTimeLine('timeline')}>
                                    <Icon
                                        path={mdiRoutesClock}
                                        title="Show Timeline"
                                        size={0.8}
                                        color="DarkSlateGray"
                                    />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Show Drives">
                                <IconButton onClick={() => showTimeLine('drives')} >
                                    <Icon
                                        path={mdiMotion}
                                        title="Show Drives"
                                        size={0.8}
                                        color="ForestGreen"
                                    />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Show Stops">
                                <IconButton onClick={() => showTimeLine('stops')}>
                                    <Icon
                                        path={mdiBusStop}
                                        title="Show Stops"
                                        size={0.8}
                                        color="GoldenRod"
                                    />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Show Events">
                                <IconButton onClick={() => showTimeLine('events')}>
                                    <Icon
                                        path={mdiAlertBox}
                                        title="Show Events"
                                        size={0.8}
                                        color="Tomato"
                                    />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Close Timeline">
                                <IconButton onClick={closeTimeLine}>
                                    <Icon
                                        path={mdiCloseOctagon}
                                        title="Close Timeline"
                                        size={0.8}
                                        color="Red"
                                    />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Expand">
                                <IconButton
                                    className={clsx(classes.expand, {
                                        [classes.expandOpen]: expanded,
                                    })}
                                    onClick={handleExpandClick}
                                    aria-expanded={expanded}
                                    aria-label="show more"
                                >
                                    <ExpandMoreIcon />
                                </IconButton>
                            </Tooltip>
                        </CardActions>
                    }

*/